import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

const propTypes = {
  target: PropTypes.string,
  exact: PropTypes.bool,
};

const defaultProps = {
  target: '',
  exact: false,
};

/**
 * Menu Item
 * @param {object} props Incoming Props
 * @returns {XML} A Menu Item
 */
const MenuItem = ({
  target, mobile, text, active, onClick, deeplink, exact,
}) => {
  if (target.indexOf('http') > -1) {
    return (
      <a
        className={`nav__${mobile ? 'mobile-' : ''}link ${active ? 'nav__link--active' : ''}`}
        data-target={text}
        href={target}
        name={text}
        data-event={text}
        data-label={text}
        aria-label={`${text} Navigation Link`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        <span className="nav__link-text">{text}</span>
      </a>
    );
  }
  if (deeplink) {
    return (
      <Link
        strict
        className={`nav__${mobile ? 'mobile-' : ''}link ${active ? 'nav__link--active' : ''}`}
        data-target={target}
        to={`${target}`}
        name={target}
        data-event={text}
        data-label={target}
        aria-label={`${text} Navigation Link`}
        onClick={onClick}
        exact={exact}
      >
        <span className="nav__link-text">{text}</span>
      </Link>
    );
  }
  return (
    <Link
      className={`nav__${mobile ? 'mobile-' : ''}link ${active ? 'nav__link--active' : ''}`}
      data-target={target}
      to={`${target}`}
      name={target}
      data-event={text}
      data-label={target}
      aria-label={`${text} Navigation Link`}
      activeClassName="nav__link--active"
      onClick={onClick}
      exact={exact}
    >
      <span className="nav__link-text">{text}</span>
    </Link>
  );
};

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/menu-item/components/menu-item.js